import {Loader, Select, SelectOptionItem} from '@logistics-frontend/blocks'
import {useController, useFormContext} from '@yandex-delivery/form'
import {useMemo} from 'react'

import {i18n} from 'src/shared/config'
import {DeliveryInterval} from 'src/shared/types'

import {Props} from './DeliveryIntervalSelect.types'
import {formatToHoursAndMinutes} from './utils/format-to-hours-and-min'

export function DeliveryIntervalSelect(props: Props) {
  const {name, intervals, isLoading = false} = props
  const {control} = useFormContext()
  const {field, fieldState} = useController({control, name})

  const options = useMemo(() => {
    return intervals.map<SelectOptionItem<DeliveryInterval>>(interval => ({
      label: `${formatToHoursAndMinutes(interval.from)} - ${formatToHoursAndMinutes(interval.to)}`,
      value: interval,
    }))
  }, [intervals])

  return (
    <Select<DeliveryInterval>
      error={fieldState.invalid}
      helperText={fieldState.error?.message}
      onBlur={field.onBlur}
      onChange={selected => {
        field.onChange(selected?.value)
      }}
      options={options}
      placeholder={i18n('ndd.delivery-policy.input.time.placeholder', 'Выберите интервал')}
      trail={isLoading && <Loader />}
      value={field?.value}
    />
  )
}
